/**
 * @param formData {Object}
 * @return {void}
 */
module.exports = function saveReturningUserData(formData) {
    const hasEmailFieldInFormData = 'Email' in formData;
    const isNotAnonymousEmail = formData['Email'] !== 'anonymous@iterable.com';

    if (hasEmailFieldInFormData && isNotAnonymousEmail) {
        localStorage.setItem("returningUserStore", JSON.stringify(formData));
    }
}